export default __webpack_public_path__ + "static/bomb-7e70a0b1ac219c75cb9a19280002fc71.png";